import { Component, inject, OnInit, signal } from '@angular/core';
import { CvxHeaderComponent } from "./shared/components/cvx-header/cvx-header.component";
import { CvxNavbarComponent } from "./shared/components/cvx-navbar/cvx-navbar.component";
import { CvxMainComponent } from "./shared/components/cvx-main/cvx-main.component";
import { CvxAsideLeftComponent } from "./shared/components/cvx-aside-left/cvx-aside-left.component";
import { CvxFooterComponent } from "./shared/components/cvx-footer/cvx-footer.component";
import { APP_CONFIG } from '@shared/constants/app-config.const';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [CvxHeaderComponent, CvxNavbarComponent, CvxMainComponent, CvxAsideLeftComponent, CvxFooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true
})
export class AppComponent {
  private authService: AuthService = inject(AuthService);
  protected APP_CONFIG: any = APP_CONFIG;
  protected lastSync = signal<string>('2024-10-25');

  constructor() {
    this.authService.login();    
  }
}
